import '../styles/style.scss';

let isZoomed = false;
const CSS_CLASS_HIDDEN = 'ra-zoom--hidden';

function calculatePositon(target, context) {
  return (100 * target) / context;
}

function zoom(clone, options, e) {
  const { offsetX, offsetY, target } = e;
  const elem = options.requiredInteraction || !options.detached ? target : clone;
  elem.style.setProperty('--zoom', options.zoomLevel);
  elem.style.setProperty('--x', `${calculatePositon(offsetX, target.offsetWidth)}%`);
  elem.style.setProperty('--y', `${calculatePositon(offsetY, target.offsetHeight)}%`);
}

function toggleZoom(clone, options, e) {
  if (isZoomed) {
    e.target.style.setProperty('--zoom', 1);
  } else {
    zoom(clone, options, e);
  }
  isZoomed = !isZoomed;
}

function adjustDetachedView(target, viewer, parent, options) {
  if (!options.detached) return;

  const targetCoords = target.getBoundingClientRect();
  const parentCoords = parent.getBoundingClientRect();

  const left = Math.abs(parentCoords.left - targetCoords.left) + targetCoords.width + 10;
  const top = parentCoords.top - targetCoords.top;

  viewer.style.setProperty('--left', `${left}px`);
  viewer.style.setProperty('--top', `${top}px`);
  viewer.classList.remove(CSS_CLASS_HIDDEN);
}

function resetZoom(zoomedElement, viewer) {
  zoomedElement.style.setProperty('--zoom', 1);
  viewer?.classList.add(CSS_CLASS_HIDDEN);
}

const RefappZoom = {
  // INFO: Vue 2.x hook
  inserted(el, binding) {
    RefappZoom.mounted(el, binding);
  },

  // INFO: Vue 3.x hook
  mounted(el, binding) {
    const options = {
      ...{
        detached: false,
        zoomLevel: 3,
        requireInteraction: false,
      },
      ...binding.value,
    };

    let viewer, clone;

    const parent = el.parentElement;
    el.classList.add('ra-zoom__target');
    parent.classList.add('ra-zoom');

    if (options.detached) {
      parent.classList.add('ra-zoom--detached');
      viewer = document.createElement('div');
      viewer.classList.add();
      clone = el.cloneNode(false);
      viewer.classList.add('ra-zoom__viewer', CSS_CLASS_HIDDEN);
      clone.classList.add('ra-zoom--detached-proportion');
      viewer.appendChild(clone);
      parent.appendChild(viewer);
    }

    if (options.requireInteraction) {
      /**
       *  TODO: Register tap events on mobile devices
       */
      parent.classList.add('ra-zoom--unselectable');
      el.addEventListener('click', toggleZoom.bind(null, clone, options));
    } else {
      /**
       * TODO: See whether we can use only one listener and have
       * `adjustDetachedView` be turned into `toggleDetachedView` or `toggleViewer`
       * which in turn only shows / hides the view pane
       */
      el.addEventListener('mousemove', zoom.bind(null, clone, options));
      el.addEventListener('mousemove', adjustDetachedView.bind(null, el, viewer, parent, options));
      el.addEventListener('mouseleave', resetZoom.bind(null, el, viewer));
    }
  },

  // INFO: unbind all listeners
  unmounted(el) {
    el.remoEventListener('click', toggleZoom);
    el.remoEventListener('mousemove', zoom);
    el.remoEventListener('mousemove', adjustDetachedView);
    el.remoEventListener('mouseleave', resetZoom);
  },
};

export default RefappZoom;
